export default "__VITE_ASSET__CfE8LDAN__"